import React from "react";
import { gql, useQuery } from "@apollo/client";
import { withStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import { useParams } from "react-router-dom";
import TableLink from "../TableLink";

const styles = theme => ({
  root: {
    marginTop: theme.spacing(3),
    overflowX: "auto",
    margin: "auto"
  },
  table: {
    minWidth: 700
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    minWidth: 300
  }
});

const GET_TOURNAMENT_TEAMS = gql`
  query teamDetailQuery($id: Int, $teamId: Int) {
    Team(id: $teamId, filter: { tournament: { id: $id } }, orderBy: name_asc) {
      id
      name
      players {
        id
        name
      }
      school {
        id
        full_name
      }
      performances(orderBy: round_number_asc) {
        round_number
        id
        points
        powers
        gets
        negs
        bonus_points
        bonuses_heard
        game {
          id
          scoreline
          round {
            name
          }
        }
      }
    }
  }
`;

function TeamDetail(props) {
  const { id, teamId } = useParams();
  const { classes } = props;

  const { loading, data, error } = useQuery(GET_TOURNAMENT_TEAMS, {
    variables: {
      id: parseInt(id),
      teamId: parseInt(teamId) || undefined
    }
  });

  return (
    <div className={classes.root}>
      {loading && !error && <p>Loading...</p>}
      {error && !loading && <p>Error</p>}
      {data && !loading && !error && (
        <div>
          {data.Team.map(t => {
            return (
              <React.Fragment key={t.id}>
                <Typography variant="h6">{t.name}</Typography>
                {!!t.school && (
                  <Typography variant="caption" display="block" gutterBottom>
                    Representing{" "}
                    <TableLink to={`/school/${t.school.id}`}>
                      {t.school.full_name}
                    </TableLink>
                  </Typography>
                )}
                <Table className={classes.table} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell key="scoreline">Scoreline</TableCell>
                      <TableCell key="powers">Powers</TableCell>
                      <TableCell key="gets">Gets</TableCell>
                      <TableCell key="negs">Negs</TableCell>
                      <TableCell key="points">Points</TableCell>
                      <TableCell key="ppb">PPB</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {t.performances.map(p => {
                      return (
                        <TableRow key={p.id}>
                          <TableCell component="th" scope="row">
                            <TableLink
                              to={`/tournament/${id}/game-detail/${p.game.id}`}
                            >
                              {p.game.scoreline}
                            </TableLink>
                          </TableCell>
                          <TableCell>{p.powers}</TableCell>
                          <TableCell>{p.gets}</TableCell>
                          <TableCell>{p.negs}</TableCell>
                          <TableCell>{p.points?.toLocaleString()}</TableCell>
                          <TableCell>
                            {(p.bonus_points / p.bonuses_heard).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                <Table
                  className={classes.table}
                  size="small"
                  style={{ width: "50%" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell key="player">Players:</TableCell>
                      {t.players.map(p => (
                        <TableCell key={p.id}>
                          <TableLink
                            to={`/tournament/${id}/individual-detail/${p.id}`}
                          >
                            {p.name}
                          </TableLink>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                </Table>
                <br />
              </React.Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default withStyles(styles)(TeamDetail);
